<template>
    <div v-if="permission && permission.version === '5'" class="fluid page_content pg_course_list">
        <div class="row page-heading pr-0">
            <div class="col-8 input module_heading" role="heading" aria-level="1">
                <span class="module_icon icon-course"></span>
                <span class="module_type_name">Course Section Management</span>
            </div>
            <div class="col-4 submit btn-container text-right">

              <!--
              selected: {{ selected.length }}
              -->

              <div class="pg_3x3_menu">
                <b-dropdown no-caret class="navigation-menu" toggle-class="ic_btn">
                  <template slot="button-content">
                    <span class="module_icon ic22-menu3x3">
                      <span class="sr-only">course menu</span>
                    </span>
                  </template>
                  <div class="links new_menu">

                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="!permission.coursePermission.create" @click="uploadCourseClicked" aria-label="upload">
                      <!-- <span class="ic_container">
                        <span class="ic icon-home"></span>
                      </span> -->
                      <span class="lnk_txt">
                        {{ $t('upload') }}
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" disabled aria-label="create">
                      <span class="lnk_txt">
                        {{ $t('create') }}
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">
                      <span class="lnk_txt">
                        {{ $t('delete') }}
                      </span>
                    </b-dropdown-item>
                    <template v-if="['All Courses', 'Modular Courses', 'Traditional Courses','Active Courses', 'Item Report Enabled Courses'].includes(currentGroup)">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" @click.prevent="showArchiveConfirm" aria-label="archive">
                        <span class="lnk_txt">
                          {{ $t('hide') }}
                        </span>
                      </b-dropdown-item>
                    </template>
                    <template v-if="['All Courses', 'Modular Courses', 'Traditional Courses', 'Hidden Courses', 'Item Report Enabled Courses'].includes(currentGroup)">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" @click.prevent="showUnArchiveConfirm" aria-label="un-archive">
                        <span class="lnk_txt">
                          {{ $t('unhide') }}
                        </span>
                      </b-dropdown-item>
                    </template>
                    <template v-if="['All Courses', 'Modular Courses', 'Traditional Courses', 'Active Courses', 'Hidden Courses', 'Item Report Enabled Courses'].includes(currentGroup)">
                      <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" @click.prevent="showItemReportConfirm" aria-label="Enable Item Analysis Report" v-if="institution.sendItemAnalysisReport">
                        <span class="lnk_txt">
                          {{ $t('enableItemAnalysisReport') }}
                        </span>
                      </b-dropdown-item>
                    </template>
                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" @click.prevent="showDisableItemReportConfirm" aria-label="Disable Item Analysis Report" v-if="institution.sendItemAnalysisReport">
                      <span class="lnk_txt">
                        {{ $t('disableItemAnalysisReport') }}
                      </span>
                    </b-dropdown-item>
                  </div>
                </b-dropdown>
              </div>

            </div>
        </div>

        <div class="course-management-section">
            <div class="page_subheading">
              <div class="course-list-left">
                <label id="catalogTitle" class="head_txt module_type_name ace_sec_hd" role="heading" aria-label="Course Sections">
                  <b-form-select
                    v-model="currentGroup"
                    :options="groups"
                    class=""
                    value-field="name"
                    text-field="name"
                    disabled-field="notEnabled"
                    :title="currentGroup"
                  ></b-form-select>
                </label>
                <span class="selected-count ace_sec_txt">{{ selected.length }} / {{ totalElements }}</span>
              </div>
              <div class="toolbar-right ui-list-toolbar">
                <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                  <option v-for="option in sizeOptions" v-bind:value="option">
                    {{ option }}
                  </option>
                </select>
                <div class="btn_container pagination_sty3">
                  <button
                    type="button"
                    :disabled="firstPage"
                    v-on:click="prev"
                    class="btn btn_trans"
                    :title="$t('previousPage')" :aria-label="$t('previousPage')"
                    v-b-tooltip.hover><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                  <span class="page_info">
                    <b-dropdown
                      variant="outline-secondary"
                      class="pagination_dropdown"
                    >
                      <template #button-content class="ic_btn btn_pg_switch">
                        <span class="current">{{ page + 1 }}</span>
                        <span class="total">({{ totalPages }})</span>
                      </template>
                      <b-dropdown-item
                        v-for="p in totalPages"
                        :key="p"
                        @click="goToPage(p)"
                        :active="p === selectedPageUI">
                          Page {{ p }}
                        </b-dropdown-item>
                    </b-dropdown>
                  </span>
                  <button
                    type="button"
                    :disabled="lastPage"
                    v-on:click="next"
                    class="btn btn_trans"
                    :title="$t('nextPage')" :aria-label="$t('nextPage')"
                    v-b-tooltip.hover><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                </div>
                <div class="search-box-container">
                  <input type="text" class="input-search" v-model="name" placeholder="search by course title" aria-label="search by title" @input="enableSearch" @keyup.enter="handleSearch">
                  <button type="button" class="btn btn_srh" @click="handleSearch" aria-label="search" :disabled="courseSearchBtnStatus">
                    <span class="ic_srh ic_search" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>
            <div class="course-management-table-container">
                <table v-if="isCoursesLoaded" class="table b-table table-bordered border">
                    <thead class="thead-light text-center">
                        <tr>
                          <th class="first-column">
                            <label class="form-checkbox">
                              <input type="checkbox" v-model="selectAll" @click="select" :disabled="(courses.length === 0) || permission.systemPermission.readOnly" aria-label="select all courses">
                              <i class="form-icon"></i>
                            </label>
                          </th>
                          <th class="second-column">Course Title</th>
                          <th class="third-column">Owner</th>
                          <th class="fourth-column">Folder</th>
                          <th class="last-column">Date Updated</th>
                          <th class="last-column">Flags</th>
                        </tr>
                    </thead>
                    <tbody v-if="courses.length > 0">
                        <tr v-for="course in courses">
                            <td class="first-column text-center">
                                <label class="form-checkbox">
                                    <input type="checkbox" :value="course.uuid" v-model="selected" :disabled="(courses.length === 0) || permission.systemPermission.readOnly" aria-label="select course">
                                    <i class="form-icon"></i>
                                </label>
                            </td>
                            <td class="second-column col_title">
                                <a href="javascript://" @click="goToCourseDashboard(course.uuid)">{{ course.title }}</a>
                                <template v-if="course.master">
                                  <btn class="ic ic_btn btn_master_course" @click="goToMasterSections(course)" title="Master Course- click to see sections" v-b-tooltip.hover>
                                    <span class="icon-master">m</span>
                                  </btn>
                                </template>
                            </td>
                            <td class="third-column col_owner">{{ course.ownerName }}</td>
                            <td class="fourth-column col_lib">{{ course.owningLibraryName }}</td>
                            <td class="last-column col_date">{{ getFormattedDateTime(course.lastUpdatedTime) }}</td>
                            <td class="last-column col_date">
                              <div class="tags_row">
                                <span class="tag ir" v-if="course.sendItemAnalysisReportCourse" title="Item Analysis Report" v-b-tooltip.hover>
                                  <span class="tag_name ir">IR</span>
                                </span>
                                <span class="tag archive" v-if="course.archived" title="Hidden Course" v-b-tooltip.hover>
                                  <span class="tag_name archive">H</span>
                                </span>
                                <span class="tag ir" v-if="course.version === 'V2'" title="Modular Course" v-b-tooltip.hover>
                                  <span class="tag_name ir">Modular</span>
                                </span>
                                <span class="tag ir" v-else title="Traditional Course" v-b-tooltip.hover>
                                  <span class="tag_name ir">Traditional</span>
                                </span>

                              </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                        	<td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div>
          <b-modal class="modal__v22_2" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
            <div slot="modal-header" class="row header-section w-100">
              <div class="col-8 hd">
                <div class="ic_container">

                </div>
                <div class="hd_txt">
                  <span>Please Confirm!</span>
                </div>
              </div>
              <div class="col-4 btn_container pr-0">
                <button class="btn_close" aria-label="close" @click="cancelDelete">
                   <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row modal_msg_container">
              <div class="col-12 msg_sec">
                <span>Are you sure you want delete these ({{ selected.length }}) Courses?</span>
              </div>
            </div>

            <div slot="modal-footer" class="w-100">
              <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
              <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
            </div>
          </b-modal>
        </div>

        <div>
          <b-modal class="modal__v22_2" ref="archiveConfirmModal" no-close-on-backdrop no-close-on-esc centered>
            <div slot="modal-header" class="row header-section w-100">
              <div class="col-8 hd">
                <div class="ic_container">

                </div>
                <div class="hd_txt">
                  <span>Please Confirm!</span>
                </div>
              </div>
              <div class="col-4 btn_container pr-0">
                <button class="btn_close" aria-label="close" @click="cancelArchive">
                   <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row modal_msg_container">
              <div class="col-12 msg_sec">
                <span>Are you sure you want {{archiveOrUnarhive}} ({{ selected.length }}) Courses?</span>
              </div>
            </div>

            <div slot="modal-footer" class="w-100">
              <b-button @click="archiveSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
              <b-button @click="cancelArchive" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
            </div>
          </b-modal>
        </div>
        <div>
          <b-modal class="modal__v22_2" ref="airConfirmModal" no-close-on-backdrop no-close-on-esc centered>
            <div slot="modal-header" class="row header-section w-100">
              <div class="col-8 hd">
                <div class="ic_container">

                </div>
                <div class="hd_txt">
                  <span>Please Confirm!</span>
                </div>
              </div>
              <div class="col-4 btn_container pr-0">
                <button class="btn_close" aria-label="close" @click="cancelAIR">
                   <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row modal_msg_container">
              <div class="col-12 msg_sec">
                <span>Are you sure you want {{airText}} for ({{ selected.length }}) Courses?</span>
              </div>
            </div>

            <div slot="modal-footer" class="w-100">
              <b-button @click="airSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
              <b-button @click="cancelAIR" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
            </div>
          </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>

</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import '../../../assets/module/sass/course/courseList.scss'
  export default {
    name: 'course-list',
    data () {
      return {
        courses: [],
        currentGroup: "Active Courses",
        groups: [{name:"Active Courses"},{name:"Modular Courses"},{name:"Traditional Courses"},{name:"Hidden Courses"}, {name:"All Courses"}, {name:"Item Report Enabled Courses"}],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalPages: 0,
        totalElements: 0,
        selectedPageUI: 1,
        name: '',
        archive: 'false',
        archiveFlag: false,
        archiveOrUnarhive : 'archive',
        airText : '',
        airFlag: false,
        itemReport: 'ALL',
        version: 'ALL',
        selected: [],
        selectAll: false,
        isCoursesLoaded: false,
        courseSearchBtnStatus: true,
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadCourseList()
        }, 500)
      })
    },

    methods: {
      ...mapActions([
        'loadAllCourses',
        'deleteCourses',
        'archiveCourses',
        'airCourses',
        'loadPermission'
      ]),
      computeGroupToShow (){
        let current = this.currentGroup
        this.archive = 'false'
        this.itemReport = 'ALL'
        this.version = 'ALL'

        if(current === 'All Courses'){
            this.archive = 'ALL'
        }

        if(current === 'Hidden Courses'){
            this.archive = 'true'
        }
        if(current === 'Active Courses'){
            this.archive = 'false'
        }
        if(current === 'Item Report Enabled Courses'){
            this.itemReport = 'true'
        }
        if(current === 'Modular Courses'){
            this.version = 'V2'
        }
        if(current === 'Traditional Courses'){
            this.version = 'V1'
        }

        this.loadCourseList()
      },
      loadCourseList () {
        this.$refs.loadingModal.show()
        this.loadAllCourses({page: this.page, count: this.pageSize, title: this.name, archive: this.archive, itemReport:this.itemReport, version:this.version}).then(result => {
          this.courses = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.selectedPageUI = result.number + 1
          this.totalElements = result.totalElements
          this.totalPages = result.totalPages
          this.$refs.loadingModal.hide()
          this.isCoursesLoaded = true
          if (this.selectAll) {
            this.selected = []
            this.selectAll = false
          }
          this.$refs.loadingModal.hide()
        })
      },

      goToPage (uiPage) {
        if (uiPage === this.selectedPageUI) return

        this.selectedPageUI = uiPage
        this.page = uiPage - 1
        this.loadCourseList()
      },

      goToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      },
      goToMasterSections(masterCourse){
          return this.$router.push({ name: 'masterSectionList' ,  params: { uuid: masterCourse.uuid, masterCourse:masterCourse }})
      },
      select () {
        this.selected = []
        if (!this.selectAll) {
          for (var i in this.courses) {
            this.selected.push(this.courses[i].uuid)
          }
        }
      },

      showDeleteConfirm () {
        if (this.selected.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },
      deleteSelected () {
        this.$refs.deleteConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.deleteCourses(this.selected).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Course(s) deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Course(s) not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Course deletion failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.loadCourseList()
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },

      cancelDelete () {
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      },
      showArchiveConfirm (){
        if (this.selected.length > 0) {
          this.archiveFlag = true
          this.archiveOrUnarhive = 'hide'
          this.$refs.archiveConfirmModal.show()
        }
      },
      showUnArchiveConfirm (){
        if (this.selected.length > 0) {
          this.archiveFlag = false
          this.archiveOrUnarhive = 'unhide'
          this.$refs.archiveConfirmModal.show()
        }
      },
      archiveSelected () {
        this.archiveFlagSelected(this.archiveFlag)
      },
      archiveFlagSelected (flag) {
        this.$refs.archiveConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.archiveCourses({itemsToArchive:this.selected, flag:flag}).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Course(s) ' + this.archiveOrUnarhive + ' successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Course(s) not archived due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Course archive failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.loadCourseList()
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },

      cancelArchive () {
        this.$refs.archiveConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      },

      cancelArchive () {
        this.$refs.archiveConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      },

      showItemReportConfirm (){
        if (this.selected.length > 0) {
          this.airFlag = true
          this.airText = 'enable item analysis report'
          this.$refs.airConfirmModal.show()
        }
      },
      showDisableItemReportConfirm (){
        if (this.selected.length > 0) {
          this.airFlag = false
          this.airText = 'disable item analysis report'
          this.$refs.airConfirmModal.show()
        }
      },
      airSelected(){
        this.airFlagSelected(this.airFlag)
      },
      airFlagSelected (flag) {
        this.$refs.airConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.airCourses({itemsToAir:this.selected, flag:flag}).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Course(s) updated for Item Analysis Report successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Course(s) not updated due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Course flag update failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.loadCourseList()
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },

      cancelAIR () {
        this.$refs.airConfirmModal.hide()
        this.selected = []
        this.selectAll = false
        this.airFlag = false
        this.airText = ''

      },
      enableSearch () {
        if (this.name.length > 0) {
          this.courseSearchBtnStatus = false;
        } else {
          this.courseSearchBtnStatus = true;
        }
      },
      handleSearch() {
        this.loadCourseList()
      },

      resetPage () {
        this.page = 0
        this.loadCourseList()
      },

      prev () {
        this.page -= 1
        this.loadCourseList()
      },

      next () {
        this.page += 1
        this.loadCourseList()
      },

      getFormattedDateTime (timeInMillis) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ' ' + amPm
        return str
      },
      uploadCourseClicked () {
        return this.$router.push({name: 'courseSectionUpload'})
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission,
        'institution': state => state.institution.institution
      })
    },
    watch: {
    currentGroup (newCurrentGroup) {
        this.computeGroupToShow()
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseList.vue